import * as React from "react";
import type { SVGProps } from "react";
const SvgDirectionrightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="directionright_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M707.755 554.752 481.92 780.587a42.667 42.667 0 1 0 60.33 60.33L840.62 542.55a43.093 43.093 0 0 0 0-60.928L542.293 183.253a42.667 42.667 0 1 0-60.33 60.331l225.834 225.835H210.773c-22.101 0-40.021 19.114-40.021 42.666s17.92 42.667 40.021 42.667h496.982z"
    />
  </svg>
);
export default SvgDirectionrightIcon;
